export default __webpack_public_path__ + "static/media/badminton.e003a6af.png";